import React from 'react'
import { useParams } from 'react-router-dom'

const PaymentReturn = () => {

    const { checkout_session_id } = useParams();
  return (
    <div>
        PaymentReturn
        {checkout_session_id}
    </div>
  )
}

export default PaymentReturn